import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  return <section id="cta" className="py-20 bg-indigo-50" data-id="element-147">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="max-w-4xl mx-auto text-center" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-150">
            Ready to Amplify Your Newsletter?
          </h2>
          <p className="text-xl text-gray-700 mb-8" data-id="element-151">
            Join hundreds of newsletter creators who are saving time and
            increasing revenue with Newsfiliate for Kit.
          </p>
          <a href="https://app.kit.com/apps/1229" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-md text-white shadow-lg hover:shadow-xl transition-shadow" style={{
          backgroundColor: '#5e60ce'
        }} target="_blank" rel="noopener noreferrer" data-id="element-152">
            Install on Kit
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-153" />
          </a>
          <div className="mt-4 space-y-1" data-id="element-154">
            <p className="text-sm font-medium text-[#5e60ce] animate-pulse" data-id="element-155">
              Free for a limited time only
            </p>
            <p className="text-gray-500" data-id="element-156">No credit card required.</p>
          </div>
        </div>
      </div>
    </section>;
}